import classNames from 'classnames';
import styled from 'styled-components';

import { CardQuality } from '__generated__/globalTypes';
import { Sparkles } from 'atoms/animations/Sparkles';
import { Star } from 'atoms/icons/Star';
import { ConditionalWrapper } from 'atoms/layout/ConditionalWrapper';
import { Horizontal } from 'atoms/layout/flex';
import { range } from 'lib/arrays';
import { qualityNames } from 'lib/players';
import type { unitMapping } from 'lib/style';

const Root = styled(Horizontal).attrs({ center: true })`
  display: inline-flex;
  gap: 1px;
  min-width: var(--quadruple-unit);
  padding: var(--half-unit) var(--half-unit);
  border-radius: var(--quadruple-unit);
  border: 1px solid var(--c-nd-500);
  background: linear-gradient(
      to bottom right,
      transparent 50%,
      var(--c-nd-150) 51%
    ),
    var(--c-nd-50-opaque);

  &.tierZero {
    color: var(--c-yellow-200);
  }
`;

type Props = {
  /*
  starRank is number value from  0 to 6
  it represents the Tier of the card
  */
  starRank: number;
  cardQuality?: CardQuality;
  size?: keyof typeof unitMapping;
};

const MAX_STARS = 5;

export const convertTierToStarRank = (quality: CardQuality) => {
  return {
    [CardQuality.TIER_0]: 6,
    [CardQuality.TIER_1]: 5,
    [CardQuality.TIER_2]: 4,
    [CardQuality.TIER_3]: 3,
    [CardQuality.TIER_4]: 2,
    [CardQuality.TIER_5]: 1,
  }[quality];
};

export const StarRank = ({ starRank, cardQuality, size = 1 }: Props) => {
  const numberOfStars = Math.min(starRank, MAX_STARS);

  const tierZero = starRank > MAX_STARS;

  return (
    <ConditionalWrapper wrap={!!tierZero} Wrapper={Sparkles}>
      <Root className={classNames({ tierZero }, 'text-center')}>
        {range(numberOfStars).map(i => (
          <Star key={i} size={size} />
        ))}
        {!!cardQuality && (
          <span className="sr-only">{qualityNames[cardQuality]}</span>
        )}
      </Root>
    </ConditionalWrapper>
  );
};
